import React, { useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import TextInput from '../../../../TextInput';
import Button from '../../../../Button';
import styles from './styles.styl';

function DiscountForm({ formatMessage, loading, onApply, serverErrors }) {
  const [coupon, setCoupon] = useState('');
  const isValid = !!coupon && !loading;

  const handleSubmit = e => {
    e.preventDefault();
    onApply(coupon);
  };

  const validationError = useMemo(
    () =>
      serverErrors
        ? formatMessage({ id: 'appointment.payment.discountError' })
        : null,
    [serverErrors],
  );

  return (
    <div styleName="Discount">
      <form onSubmit={handleSubmit}>
        <div styleName="DiscountTitle">
          {formatMessage({ id: `appointment.payment.discountTitle` })}
        </div>
        <div styleName="DiscountText">
          {formatMessage({ id: `appointment.payment.discountText` })}
        </div>
        <div styleName="DiscountInput">
          <TextInput
            styleName="DiscountInput-control"
            type="text"
            limit={10}
            label={formatMessage({ id: 'appointment.payment.couponCode' })}
            placeholder={formatMessage({
              id: 'appointment.payment.couponCode',
            })}
            onChange={value => setCoupon(value)}
            value={coupon}
          />
          <Button type="submit" disabled={!isValid} color="primary" raised>
            {formatMessage({ id: 'appointment.payment.apply' })}
          </Button>
        </div>
        <div styleName="DiscountError">{validationError}</div>
      </form>
    </div>
  );
}

DiscountForm.propTypes = {
  formatMessage: PropTypes.func,
  loading: PropTypes.bool,
  onApply: PropTypes.func,
  serverErrors: PropTypes.object,
};

export default CSSModules(DiscountForm, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/DicountForm/index.jsx